import {ContextMenu} from './context_menu';

import {SingleText} from '../elements/single_text';
import {LabelLine} from '../elements/label_line';

ContextMenu.SingleText = SingleText;
ContextMenu.LabelLine = LabelLine;

export {ContextMenu};
